import React, { Component } from 'react';

class Tabs extends Component {
	render() {

		const children = this.props.children.length ? this.props.children : [ this.props.children ],
			{ title, firstTab, lastTab } = this.props;

		return (
			<div>
				<section className="row">
					<div className="col-centered col-xs-12 col-md-8 col-lg-6 text-center">
						<h1 className="h1 brand-color">{ title }</h1>
					</div>
				</section>
				<section className="row">
					<nav id="tabNavigation" className="col-centered col-xs-12 col-md-8 col-lg-6">
						<ul className="nav nav-default tabs-nav text-center">
							{
								children.map( ( child, index ) => {

									if (firstTab) return <li key={ index } className="border padding-none col-xs-6">{ child }</li>;

									if (lastTab) return <li key={ index } className="border padding-none col-xs-6">{ child }</li>;

									return <li key={ index } className="border padding-none col-xs-6">{ child }</li>;
								} )
							}
						</ul>
					</nav>
				</section>
				<hr />
			</div>
		);
	};
}

export default Tabs;



// WEBPACK FOOTER //
// src/client/components/common/elements/Tabs.js